function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';
import camelCase from 'lodash/camelCase';
import map from 'lodash/map';
import App from 'modules/App';
import FormGroup from 'components/Form/FormGroup';
import Select from 'components/Form/Select';
import Button from 'components/Form/Button';
import intlShape from 'shapes/intlShape';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from '../Results/Results.pcss';
var _React_PureComponent;
class ChartControls extends (_React_PureComponent = React.PureComponent) {
    renderButtonOptions(mode) {
        if (this.props.mode !== mode) {
            return null;
        }
        switch(mode){
            case 'AGGREGATED':
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        this.renderCalculationFormulas(),
                        this.renderAggregateBy()
                    ]
                });
            case 'GROUPED':
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        this.renderCalculationFormulas(),
                        this.renderGroupBy()
                    ]
                });
            default:
                return null;
        }
    }
    renderPresentationTypes() {
        const { isInProgress } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "form-label",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.presentationTypes))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: cn('btn-group col-auto', styles.chartControls__wrapper),
                        children: map(constants.MODES, (mode, index)=>/*#__PURE__*/ _jsxs(Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Button, {
                                        styleModifier: "quinary",
                                        className: cn('btn--filled', {
                                            'text--primary': mode === this.props.mode
                                        }),
                                        labelMessage: messages.buttons[mode.toLowerCase()],
                                        isDisabled: isInProgress,
                                        onClick: ()=>this.props.onSetMode(mode)
                                    }, mode),
                                    this.renderButtonOptions(mode),
                                    index < constants.MODES.length - 1 && /*#__PURE__*/ _jsx("div", {
                                        className: styles.buttonsSeparator,
                                        children: /*#__PURE__*/ _jsx("div", {})
                                    })
                                ]
                            }, `${mode}-presentation-button`))
                    })
                })
            ]
        });
    }
    renderCalculationFormulas() {
        const { mode, calculationFormula, isInProgress, intl } = this.props;
        const calculationFormulas = [
            ...constants.CALCULATION_FORMULAS
        ];
        if (mode === 'AGGREGATED') {
            calculationFormulas.shift();
        }
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "calculationFormula",
            className: styles.sortOptions__option,
            formValues: {
                values: {
                    calculationFormula
                }
            },
            children: /*#__PURE__*/ _jsx(Select, {
                optionsFrom: map(calculationFormulas, (formula)=>({
                        value: formula,
                        label: intl.formatMessage(messages.formulas[camelCase(formula)])
                    })),
                selectedFieldClasses: styles.selectedFieldClasses,
                valueKey: "value",
                labelKey: "label",
                isDisabled: isInProgress,
                onChange: (input)=>this.props.onSetCalculationFormula(input.value)
            })
        });
    }
    renderAggregateBy() {
        const { mode, aggregateBy, isInProgress, intl } = this.props;
        if (mode !== 'AGGREGATED') {
            return null;
        }
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "aggregateBy",
            className: styles.sortOptions__option,
            formValues: {
                values: {
                    aggregateBy
                }
            },
            children: /*#__PURE__*/ _jsx(Select, {
                optionsFrom: map(constants.AGGREGATE_BY, (unit)=>({
                        value: unit,
                        label: intl.formatMessage(messages.aggregateBy[unit.toLowerCase()])
                    })),
                selectedFieldClasses: styles.selectedFieldClasses,
                valueKey: "value",
                labelKey: "label",
                isDisabled: isInProgress,
                onChange: (input)=>this.props.onSetAggregateBy(input.value)
            })
        });
    }
    renderGroupBy() {
        const { mode, groupBy, isInProgress, intl } = this.props;
        if (mode !== 'GROUPED') {
            return null;
        }
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "groupBy",
            className: styles.sortOptions__option,
            formValues: {
                values: {
                    groupBy
                }
            },
            children: /*#__PURE__*/ _jsx(Select, {
                optionsFrom: map(constants.GROUP_BY, (type)=>({
                        value: type,
                        label: intl.formatMessage(messages.groupBy[type.toLowerCase()])
                    })),
                selectedFieldClasses: styles.selectedFieldClasses,
                valueKey: "value",
                labelKey: "label",
                isDisabled: isInProgress,
                onChange: (input)=>this.props.onSetGroupBy(input.value)
            })
        });
    }
    renderFilters() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "form-label",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.flagsFilters))
                        }),
                        this.props.renderFlagFilters()
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "form-label",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.periodWithResults))
                        }),
                        this.props.renderDatePresets()
                    ]
                })
            ]
        });
    }
    render() {
        const { printMode, isInProgress } = this.props;
        if (printMode) return null;
        return /*#__PURE__*/ _jsx("div", {
            className: cn(styles.chartControls, {
                fadingLoader: isInProgress
            }),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row justify-content-between",
                children: [
                    this.props.deviceMode !== 'AGP' && /*#__PURE__*/ _jsx(_Fragment, {
                        children: this.renderPresentationTypes()
                    }),
                    this.renderFilters()
                ]
            })
        });
    }
}
_define_property(ChartControls, "propTypes", {
    // Explicit props
    start: PropTypes.number,
    end: PropTypes.number,
    renderDatePresets: PropTypes.func,
    renderFlagFilters: PropTypes.func,
    isInProgress: PropTypes.bool,
    // Implicit props
    mode: PropTypes.oneOf(constants.MODES),
    deviceMode: PropTypes.oneOf(constants.DEVICES_MODES),
    calculationFormula: PropTypes.oneOf([
        ...constants.CALCULATION_FORMULAS,
        ...constants.CALCULATION_FORMULAS_CGM
    ]),
    aggregateBy: PropTypes.oneOf(constants.AGGREGATE_BY),
    groupBy: PropTypes.oneOf([
        ...constants.GROUP_BY,
        ...constants.GROUP_BY_CGM
    ]),
    intl: intlShape,
    printMode: PropTypes.bool,
    featureToggles: PropTypes.arrayOf(PropTypes.string),
    // Implicit actions
    onSetMode: PropTypes.func,
    onSetDeviceMode: PropTypes.func,
    onSetCalculationFormula: PropTypes.func,
    onSetAggregateBy: PropTypes.func,
    onSetGroupBy: PropTypes.func
});
const mapStateToProps = (state)=>({
        mode: selectors.mode(state),
        deviceMode: selectors.deviceMode(state),
        calculationFormula: selectors.calculationFormula(state),
        aggregateBy: selectors.aggregateBy(state),
        groupBy: selectors.groupBy(state),
        printMode: App.selectors.printMode(state),
        featureToggles: App.selectors.featureToggles(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onSetMode: (mode)=>dispatch(actions.setMode(mode)),
        onSetDeviceMode: (deviceMode)=>dispatch(actions.setDeviceMode(deviceMode)),
        onSetCalculationFormula: (calculationFormula)=>dispatch(actions.setCalculationFormula(calculationFormula)),
        onSetAggregateBy: (aggregateBy)=>dispatch(actions.setAggregateBy(aggregateBy)),
        onSetGroupBy: (groupBy)=>dispatch(actions.setGroupBy(groupBy))
    });
const ConnectedChartControls = connect(mapStateToProps, mapDispatchToProps)(injectIntl(ChartControls));
export default ConnectedChartControls;
